module.exports = __webpack_public_path__ + "img/w66.3c1eb066.svg";